<template>
  <div>
    <div
      v-if="!hideHero"
      id="hero"
      :class="' bg-[#971111] text-white ' + heroClass + ' w-full bg-cover bg-center no-repeat min-h-[100px] lg:h-[165px] flex flex-col place-items-center place-content-center'"
    >
      <h2
        v-if="uptitle"
        class="font-source-serif-pro text-lg lg:text-xl font-bold text-center text-yellow"
      >
        {{ uptitle }}
      </h2>
      <h1
        class="font-source-serif-pro text-2xl lg:text-4xl font-bold text-center"
        v-html="title"
      />
      <h2
        v-if="subtitle"
        class="font-source-serif-pro text-lg lg:text-xl font-bold text-center text-yellow"
      >
        {{ subtitle }}
      </h2>
      <h3
        v-if="subsubtitle"
        class="font-source-serif-pro text-sm lg:text-base text-center text-yellow"
      >
        {{ subsubtitle }}
      </h3>
    </div>
    <!-- hero end -->
    <div class="w-full  max-w-7xl md:max-w-lg lg:max-w-6xl 2xl:max-w-7xl mx-auto">
      <!-- breadcrumb -->
      <div
        v-if="breadcrumb.length"
        id="breadcrumb"
        class="w-full mt-4 px-3 lg:px-auto break-words overflow-hidden whitespace-nowrap overflow-ellipsis"
      >
        <nuxt-link
          to="/"
          class="cursor-pointer underline"
        >
          <img
            src="/img/breadcrum_house_icon.svg"
            class="inline w-[12px] h-[12px] border-b border-solid border-gray"
          >
        </nuxt-link>
        <span
          v-for="(item, index) in breadcrumb"
          :key="index"
          class="font-source-sans-pro text-base pl-2"
        >
          <span v-if="item.name">/&nbsp;&nbsp;<nuxt-link
            :to="item.url"
            class="cursor-pointer underline"
          >{{ item.name }}</nuxt-link></span>
          <span v-else>/&nbsp;&nbsp;{{ item }}</span>
        </span>
      </div>
      <!-- breadcrumb end -->
      <div class="mt-4 mb-20">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    uptitle: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    subsubtitle: {
      type: String,
    },
    heroClass: {
      type: String,
      required: true
    },
    hideHero:{
      type:Boolean,
      default:false
    },
     hideHeroOnMobile:{
      type:Boolean,
      default:false
    },
    breadcrumb: {
      type: Array,
      default: () => { return [] }
    }
  }
}
</script>